module.exports = "/images/vendor/flag-icon-css/flags/4x3/so.svg?f91fb92c0ca6934e1e008f8f97e58c63";